import { reportAppCrash } from "./backend_helper"

/**
 * Detects device type from user agent
 * @returns {string} - "win" | "mac" | "and" | "ios"
 */
const detectDeviceType = () => {
    const userAgent = navigator.userAgent.toLowerCase()

    if (userAgent.includes('windows')) {
        return 'win'
    } else
        if (userAgent.includes('android')) {
            return 'and'
        } else if (userAgent.includes('iphone') || userAgent.includes('ipad') || userAgent.includes('ipod')) {
            return 'ios'
        } else if (userAgent.includes('mac')) {
            return 'mac'
        }
}

/**
 * Gets current screen/route identifier
 * @returns {string} - Current route path (max 255 chars)
 */
const getScreenID = () => {
    const pathname = window.location.pathname
    // Truncate to 255 characters if needed
    return pathname.length > 255 ? pathname.substring(0, 255) : pathname
}

/**
 * Formats error data for API submission
 * @param {Error} error - The error object
 * @param {object} errorInfo - Additional error info (e.g., componentStack from React)
 * @returns {object} - Formatted error data matching API spec
 */
export const formatErrorForAPI = (error, errorInfo = {}) => {
    const errorMessage = error?.message || 'Unknown error occurred'

    // Combine error stack and component stack
    let stackTrace = error?.stack || 'No stack trace available'

    if (errorInfo?.componentStack) {
        stackTrace += '\n\nComponent Stack:' + errorInfo.componentStack
    }

    return {
        deviceType: detectDeviceType(),
        screenID: getScreenID(),
        errorMessage: errorMessage,
        stackTrace: stackTrace
    }
}

/**
 * Sends error report to the API
 * @param {object} errorData - Formatted error data
 * @returns {Promise} - API call promise
 */
export const sendErrorReport = async (errorData) => {
    try {
        // Fire-and-forget: don't block UI if this fails
        await reportAppCrash(errorData)
        console.log('[ERROR BOUNDARY] Error report sent successfully')
    } catch (reportError) {
        // Silently fail - don't want to error while reporting errors
        console.error('[ERROR BOUNDARY] Failed to send error report:', reportError)
    }
}

/**
 * Main function to handle and report errors
 * @param {Error} error - The error object
 * @param {object} errorInfo - Additional error info
 */
export const handleAndReportError = (error, errorInfo) => {
    // Log to console for debugging
    console.error('[ERROR BOUNDARY] Caught error:', error)
    if (errorInfo?.componentStack) {
        console.error('[ERROR BOUNDARY] Component stack:', errorInfo.componentStack)
    }

    // Format and send to API
    const errorData = formatErrorForAPI(error, errorInfo)
    sendErrorReport(errorData)
}
